import posthog from "posthog-js";
import { POSTHOG_KEY, POSTHOG_HOST } from "./src/config/analytics";

// Keep client-side render identical to SSR (same wrapPageElement) so the
// site-wide structured data hydrates without a mismatch.
export { wrapPageElement } from "./gatsby-shared";

export const onClientEntry = () => {
  if (typeof window === "undefined") return;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: false,
    capture_pageleave: true,
    autocapture: true,
    rageclick: true,
    capture_performance: true,
    enable_heatmaps: true,
    person_profiles: "always",
    session_recording: { maskAllInputs: true },
  });
  // Conversion events (enquiry_submitted, join_wizard_started) capture via
  // window.posthog, so the initialized instance must be attached here.
  window.posthog = posthog;
};

export const onRouteUpdate = () => {
  if (typeof window === "undefined") return;
  posthog.capture("$pageview");
};
